import React, { useState, useEffect } from "react";
import OnloadPopup from "./OnloadPopup";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import banner from "./images/about-us-banner.png";
import Section1 from "./images/Section-1-img.png";
import aboutimg1 from "./images/about-img-12.png";

import aboutthumb from "./images/about-thumb-4.png";
import aboutthumb1 from "./images/about-thumb-2.png";
import aboutthumb2 from "./images/about-thumb-5.png";

import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
  disable: isMobile,
});

const photogallery = [
  require("./images/pg-h-1.png"),
  require("./images/pg-h-2.png"),
  require("./images/pg-h-3.png"),
  require("./images/pg-h-4.png"),
  require("./images/pg-h-5.png"),
  require("./images/pg-h-6.png"),
  require("./images/pg-h-7.png"),
  require("./images/pg-h-8.png"),
];

const instagallery = [
  require("./images/insta-h-1.png"),
  require("./images/insta-h-2.png"),
  require("./images/insta-h-3.png"),
  require("./images/insta-h-4.png"),
  require("./images/insta-h-5.png"),
  require("./images/insta-h-6.png"),
  require("./images/insta-h-7.png"),
  require("./images/insta-h-8.png"),
  require("./images/insta-h-7.png"),
  require("./images/insta-h-8.png"),
];

function PrivacyPolicy() {
  {
    /*Popup scripts start */
  }
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show the popup after 30 seconds
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // Change to 30000 for 30 seconds

    // Clear the timer on cleanup
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };
  {
    /*Popup scripts End */
  }
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false, // Only animate once
      disable: () => window.innerWidth < 768, // Disable on mobile (screen width < 768px)
    });
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      {/* {showPopup && <OnloadPopup closePopup={closePopup} />} */}
      <div>
        <div className="Banner">
          <img src={banner} alt="" />
          <h1>Privacy Policy</h1>
        </div>
        <div className="about-section-1-bg  ">
          <div className="wrapper">
            <div className="home-section-1-wrap">
              <div
                className="home-section-1-2 privacypolicy"
                data-aos="fade-up-left"
              >
                <h2>Introduction</h2>
                <p>
                  Rostre Spaces ("we," "our," or "us") is committed to
                  protecting your privacy. This Privacy Policy outlines how we
                  collect, use, and safeguard your personal information,
                  particularly in relation to our LinkedIn Lead Generation Ads
                  and other marketing activities.
                </p>
                <h3> Information We Collect</h3>
                <p>
                  When you interact with our LinkedIn Lead Generation Ads or
                  visit our website, we may collect the following personal
                  information:
                </p>
                <ul>
                  <li>First Name</li>
                  <li>Last Name</li>
                  <li>Phone Number</li>
                  <li>Email</li>
                  <li>Any other information you voluntarily provide</li>
                </ul>
                <h3>How We Use Your Information</h3>
                <p>We use the collected information to:</p>
                <ul>
                  <li>
                    Respond to your inquiries and provide requested information
                  </li>
                  <li>
                    Send you marketing communications, if you have opted in
                  </li>
                  <li>Improve our products and services</li>
                  <li>Comply with legal obligations</li>
                </ul>
                <h3>Data Sharing and Disclosure</h3>
                <p>
                  We do not sell or rent your personal information to third
                  parties. We may share your information with:
                </p>
                <ul>
                  <li>
                    Service providers who assist in our business operations
                    (e.g., email marketing services)
                  </li>
                  <li>
                    Legal authorities if required by law or to protect our
                    rights
                  </li>
                </ul>
                <h3>Data Retention</h3>
                <p>
                  We retain your personal information only as long as necessary
                  to fulfill the purposes outlined in this policy, unless a
                  longer retention period is required or permitted by law.
                </p>

                <h3>Your Rights</h3>
                <p>
                  Depending on your location, you may have the following rights
                  regarding your personal information:
                </p>
                <ul>
                  <li>
                    Access: Request a copy of the information we hold about you
                  </li>
                  <li>
                    Correction: Request corrections to any inaccurate
                    information
                  </li>
                  <li>
                    Deletion: Request deletion of your personal information
                  </li>
                  <li>Objection: Object to certain processing activities</li>
                  <li>
                    Withdrawal of Consent: Withdraw consent at any time, where
                    applicable
                  </li>
                </ul>
                <p>
                  To exercise any of these rights, please contact us at{" "}
                  <a href="mailto:info@rostre.in">info@rostre.in.</a>
                </p>
                <h3>Data Security</h3>
                <p>
                  We implement appropriate technical and organizational measures
                  to protect your personal information against unauthorized
                  access, alteration, disclosure, or destruction. However, no
                  internet transmission is completely secure, and we cannot
                  guarantee absolute security.
                </p>
                <h3>Children's Privacy</h3>
                <p>
                  Our services are not directed to individuals under the age of
                  18. We do not knowingly collect personal information from
                  children under 18.
                </p>
                <h3>Changes to This Privacy Policy</h3>
                <p>
                  We may update this Privacy Policy from time to time. Any
                  changes will be posted on this page with an updated effective
                  date.
                </p>
                <h3>Contact Us</h3>
                <p>
                  If you have any questions or concerns about this Privacy
                  Policy or our data practices, please contact us at:
                </p>

                <p>
                  Rostre Spaces
                  <br />
                  info@rostre.in
                  <br />
                  Hyderabad, Telangana, India
                </p>
                {/*                 
                <Link to="/why-choose-rostre" className="button-3" on>
                  Learn More
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
